import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claims`;

export interface DeleteClaimByIdCommandArgs {
  claimId: string;
}

export const deleteClaimByIdRequest = ({
  claimId,
}: DeleteClaimByIdCommandArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimId}`,
  config: { method: SUPPORTED_METHODS.DELETE },
});

export const deleteClaimByIdCommand = async (
  args: DeleteClaimByIdCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    return await executeQuery<BaseBackResponse>(deleteClaimByIdRequest(args));
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
